// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"352":"es","665":"pt","697":"ru","913":"de","922":"zh"}[chunkId] || chunkId) + "." + {"101":"c77fd2b4","352":"8a538152","374":"5e774330","541":"89ddd0c3","665":"74e30c8d","697":"55e97373","913":"f5c26d71","922":"e781602c"}[chunkId] + ".chunk.js";
};